import { Box, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { AppTheme, hexToRgbA } from "theme";
import MessageBottomText from "./messageBottomText";
import MessageStatus from "./messageStatus";
import { MessageVariant } from "./types";
import { IMessage, MessageRole } from "../type";
import { useIsVisibleOnce } from "utils/helper";
import PointMessage from "./pointMessage";


interface IProps {
  message: IMessage;
  onRead: () => void;
  onClick?: () => void;
}

export default function Message(props: IProps) {
  const {
    message,
    onRead,
    onClick,
  } = props;

  const [ref, visible] = useIsVisibleOnce({ threshold: 0.2 })

  const variant: MessageVariant = useMemo(() => {
    if (message.role === "Client") {
      return "out";
    }
    return "in";
  }, [message]);

  const background = useMemo(() => {
    return variant === "out" ? {
      backgroundColor: hexToRgbA(AppTheme.buttonBg, 0.08),
      '@media (prefers-color-scheme: dark)': {
        backgroundColor: hexToRgbA(AppTheme.buttonBgDark, 0.08),
      }
    } : {
      backgroundColor: AppTheme.bg,
      '@media (prefers-color-scheme: dark)': {
        backgroundColor: AppTheme.bgDark,
      }
    }
  }, [variant])
  const noBorderField = useMemo(() => variant === "out" ? "borderBottomRightRadius" : "borderBottomLeftRadius", [variant])
  const delivered = useMemo(() => message.statuses.filter((s)=>s.role !== MessageRole.Client && !!s.delivered_at).length > 0, [message]);
  const read = useMemo(() => message.statuses.filter((s)=>s.role !== MessageRole.Client && !!s.read_at).length > 0, [message]);
  const readInMessages = useMemo(() => message.statuses.filter((s)=>s.role === MessageRole.Client && !!s.read_at).length > 0, [message]);

  useEffect(() => {
    if(visible && !readInMessages && message.role !== MessageRole.Client){
      onRead()
    }
  }, [visible, readInMessages, message, onRead])


  return (
    <Box
      ref={ref}
      sx={{
        alignSelf: variant === "out" ? "flex-end" : "flex-start",
        maxWidth: "75%",
        display: "flex",
        flexDirection: "column",
        alignItems: variant === "out" ? "flex-end" : "flex-start",
      }}
    >
      <Box
        sx={{
          ...background,
          borderRadius: 3,
          [noBorderField]: 0,
          px: 1.5,
          py: 1,
        }}
        onClick={onClick}
      >
        {!!message.point ? (
          <PointMessage message={message} />
        ) : (
          <Typography
            sx={{
              whiteSpace: "pre-wrap",
            }}
          >{message.message}</Typography>
        )}
        <MessageStatus
          variant={variant}
          date={message.created_at}
          delivered={delivered}
          read={read}
        />
      </Box>
      {variant === "out" && !delivered && (
        <MessageBottomText
          variant={variant}
          type={message.id ? "send" : "sending"}
        />
      )}
    </Box>
  )
}